import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-safe-guard-prize',
  templateUrl: './safe-guard-prize.component.html',
  styleUrls: ['./safe-guard-prize.component.css']
})
export class SafeGuardPrizeComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  type: number;

  @Output()
  onPriceChange = new EventEmitter();

  public price = 0;

  constructor() {
  }

  ngOnInit() {
  }

  public onPriceChanged() {
    this.onPriceChange.emit({type: this.type, price: this.price});
  }

}
